import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';

function ItemShop({ playerId }) {
  const [items, setItems] = useState([]);
  const [dfgDollars, setDfgDollars] = useState(0);
  const [inventory, setInventory] = useState([]); // Added inventory state
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [quantities, setQuantities] = useState({});

useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [shopRes, bankRes, invRes] = await Promise.all([
          fetch(`${API_BASE_URL}/shop-items`),
          fetch(`${API_BASE_URL}/bank/${playerId}`),
          fetch(`${API_BASE_URL}/my-inventory/${playerId}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          })
        ]);

        const [shopText, bankText, invText] = await Promise.all([
          shopRes.text(),
          bankRes.text(),
          invRes.text()
        ]);

        console.log('ItemShop raw responses:', {
          shop: shopText,
          bank: bankText,
          inventory: invText
        });

        if (!shopRes.ok) throw new Error(`Shop HTTP ${shopRes.status}: ${shopText || shopRes.statusText}`);
        if (!bankRes.ok) throw new Error(`Bank HTTP ${bankRes.status}: ${bankText || bankRes.statusText}`);
        if (!invRes.ok) throw new Error(`Inventory HTTP ${invRes.status}: ${invText || invRes.statusText}`);

        const [shopItems, bankData, invData] = [
          JSON.parse(shopText),
          JSON.parse(bankText),
          JSON.parse(invText)
        ];

        setItems(shopItems);
        setDfgDollars(bankData.dfgDollars || 0);
        setInventory(invData.items || []);
        setQuantities(shopItems.reduce((acc, item) => ({ ...acc, [item.itemId]: 1 }), {}));
      } catch (error) {
        console.error('Error in ItemShop:', error.message);
        setMessage('Error: ' + error.message);
      } finally {
        setLoading(false);
      }
    };
    if (playerId) fetchData();
  }, [playerId]);

  const purchaseItem = async (itemId) => {
    const quantity = quantities[itemId] || 1;
    try {
      const res = await fetch(`${API_BASE_URL}/purchase-item`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ playerId, itemId, quantity })
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      setDfgDollars(data.dfgDollars);
      setMessage(data.message);

      // Refresh inventory
      const invRes = await fetch(`${API_BASE_URL}/my-inventory/${playerId}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      if (!invRes.ok) throw new Error('Inventory refresh failed');
      const invData = await invRes.json();
      setInventory(invData.items || []);
    } catch (error) {
      setMessage('Error: ' + error.message);
    }
  };

  if (!playerId) return <p>Please log in to shop.</p>;
  if (loading) return <p>Loading shop...</p>;

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ textAlign: 'center', color: '#4CAF50' }}>DFG$ Item Shop</h1>
      <div style={{ background: '#f9f9f9', padding: '15px', borderRadius: '8px', marginBottom: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <h2 style={{ color: '#4CAF50', marginTop: 0 }}>Available Items</h2>
        <div style={{ marginBottom: '15px' }}>
          <span style={{ fontWeight: 'bold', color: '#333' }}>DFG$ Balance: {dfgDollars}</span>
          {message && (
            <p style={{ color: message.includes('Error') ? 'red' : '#4CAF50', margin: '10px 0 0 0' }}>{message}</p>
          )}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '15px' }}>
          {items.map(item => (
            <div
              key={item.itemId}
              style={{
                padding: '10px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                background: '#fff',
              }}
            >
              {item.artUrl && (
                <img
                  src={item.artUrl}
                  alt={item.name}
                  style={{ width: '150px', height: '150px', objectFit: 'cover', borderRadius: '5px', marginBottom: '10px', display: 'block', margin: '0 auto' }}
                />
              )}
              <p style={{ fontWeight: 'bold', color: '#333', margin: '5px 0' }}>{item.name}</p>
              <p style={{ color: '#666', margin: '5px 0' }}>{item.price} DFG$</p>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                <input
                  type="number"
                  min="1"
                  value={quantities[item.itemId] || 1}
                  onChange={(e) => setQuantities({ ...quantities, [item.itemId]: parseInt(e.target.value) || 1 })}
                  style={{ width: '60px', padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }}
                />
                <button
                  onClick={() => purchaseItem(item.itemId)}
                  style={{
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    padding: '8px 15px',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  Buy
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Optional: Show current inventory */}
      <div style={{ background: '#f9f9f9', padding: '15px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <h2 style={{ color: '#4CAF50', marginTop: 0 }}>Your Inventory</h2>
        {inventory.length > 0 ? (
          <ul>
            {inventory.map(item => (
              <li key={item.itemId}>{item.name} (x{item.quantity})</li>
            ))}
          </ul>
        ) : (
          <p>No items in inventory.</p>
        )}
      </div>
    </div>
  );
}

export default ItemShop;